import { useEffect, useState } from 'react';
import { apiFetch } from '../../utils/api';
import PositionConstants from '../../constants/positions';
import ProtectedAdminRoute from '../../components/ProtectedAdminRoute';
import '../../styles/admin/AddMember.css';
import '../../styles/admin/EditMember.css';
import FileUpload from '../../components/FileUpload';

// Removed BACKEND_URL, use apiFetch instead

// Use PositionConstants.OPTIONS for position choices

export default function EditMember() {
  const [members, setMembers] = useState([]);
  const [search, setSearch] = useState('');
  const [results, setResults] = useState([]);
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState('');
  const [allNames, setAllNames] = useState([]);

  useEffect(() => {
    apiFetch('/api/members')
      .then(data => {
        setMembers(data.members || []);
        setAllNames((data.members || []).map(m => m.name));
      });
  }, []);


  useEffect(() => {
    if (search) {
      setResults(members.filter(m => m.name.toLowerCase().includes(search.toLowerCase())));
    } else {
      setResults([]);
    }
  }, [search, members]);

  const handleSelect = name => {
    const member = members.find(m => m.name === name);
    if (member) {
      // Ensure position is always an array
      setForm({
        ...member,
        position: Array.isArray(member.position) ? member.position : (member.position ? [member.position] : [])
      });
      setMessage('');
    }
  };

  const handleChange = e => {
    const { name, value, multiple, options } = e.target;
    if (multiple) {
      // For multi-select, build array of selected values
      const selected = Array.from(options).filter(opt => opt.selected).map(opt => opt.value);
      setForm(f => ({ ...f, [name]: selected }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const data = await apiFetch(`/api/members/${form._id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    console.log('Edit response:', data); // See what backend returns
    if (data && (data.success || data.ok || data.updated || data.status === 'success')) {
      setMessage('Member updated!');
      setMembers(members.map(m => {
        if (m._id === form._id) {
          return {
            ...form,
            position: Array.isArray(form.position) ? form.position : (form.position ? [form.position] : [])
          };
        } else {
          return m;
        }
      }));
    } else if (data && !data.error) {
      setMessage('Member updated!');
      setMembers(members.map(m => {
        if (m._id === form._id) {
          return {
            ...form,
            position: Array.isArray(form.position) ? form.position : (form.position ? [form.position] : [])
          };
        } else {
          return m;
        }
      }));
    } else {
      setMessage('Error updating member');
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to delete "${form.name}"? This cannot be undone.`)) return;
    const data = await apiFetch(`/api/members/${form._id}`, { method: 'DELETE' });
    if (data && data.success) {
      setMessage('Member deleted!');
      setForm(null);
      setSearch('');
      setMembers(members.filter(m => m._id !== form._id));
    } else {
      setMessage('Error deleting member');
    }
  };

  return (
    <ProtectedAdminRoute>
      <div className="add-project-flex">
      <div className="edit-project-form">
        <h2>Edit Team Member</h2>
        <input
          type="text"
          placeholder="Search member by name..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          list="member-names"
          autoComplete="off"
          style={{ marginBottom: '1rem' }}
        />
        <datalist id="member-names">
          {allNames.map(name => (
            <option key={name} value={name} />
          ))}
        </datalist>
        {search && results.some(m => m.name === search) && !form && (
          <button
            style={{ marginBottom: '1rem' }}
            onClick={() => handleSelect(search)}
            type="button"
          >
            Edit "{search}"
          </button>
        )}
        {form && (
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                id="name"
                name="name"
                placeholder="Full Name"
                value={form.name}
                onChange={handleChange}
                required
                autoComplete="off"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="position">Position</label>
              <select
                id="position"
                name="position"
                value={form.position}
                onChange={handleChange}
                multiple
                required={form.position && form.position.length === 0}
                size={PositionConstants.OPTIONS.length}
                style={{ minHeight: `${PositionConstants.OPTIONS.length * 2}em`, fontSize: '1.1em' }}
              >
                {PositionConstants.OPTIONS.map(position => (
                  <option key={position} value={position}>{position}</option>
                ))}
              </select>
            </div>
            
            <div className="form-group">
              <FileUpload
                label="Member Image (Optional)"
                currentUrl={form.image}
                onUpload={(url) => setForm({...form, image: url})}
                accept="image/*"
                showPreview={true}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="linkedin">LinkedIn URL (Optional)</label>
              <input
                id="linkedin"
                name="linkedin"
                placeholder="https://linkedin.com/in/username"
                value={form.linkedin || ''}
                onChange={handleChange}
                type="url"
                autoComplete="off"
              />
            </div>
            
            <button type="submit">Save Changes</button>
            <button
              type="button"
              style={{
                marginTop: "1rem",
                background: "#e53935",
                color: "#fff",
                border: "none",
                borderRadius: "9999px",
                padding: "1rem 2.5rem",
                fontWeight: 700,
                fontSize: "1.1rem",
                cursor: "pointer",
                transition: "background 0.2s"
              }}
              onClick={handleDelete}
            >
              Remove Member
            </button>
          </form>
        )}
        {message && <div>{message}</div>}
      </div>
    </div>
    </ProtectedAdminRoute>
  );
}